import { z } from 'zod';

export enum FORM_TYPES {
  FORM = 'FORM',
  DATA = 'DATA'
}

export enum FormFieldTypes {
  HEADING = 'HEADING',
  DATE = 'DATE',
  TIME = 'TIME',
  INPUT = 'INPUT',
  TEXTAREA = 'TEXTAREA',
  RADIO = 'RADIO',
  RATING = 'RATING'
}

export const FormFieldTypesValues = Object.keys(FormFieldTypes) as any;

export const formFieldSchema = z.array(
  z.object({
    uuid: z.string().uuid(),
    label: z.string().min(3, { message: 'Field label must be 3 or more characters long' }),
    type: z.enum(FormFieldTypesValues),
    rating: z.number().optional(),
    items: z.array(z.string()).optional()
  })
);

export const formSchema = z.object({
  title: z.string().min(3, { message: 'Title must be 3 or more characters long' }),
  details: z.string().optional(),
  tags: z.array(z.any()).optional(),
  startDate: z.string().min(1, { message: 'Start date should not empty' }),
  endDate: z.string().min(1, { message: 'End date should not empty' }),
  fields: formFieldSchema
});
